export class DynamicStyleHelper {

    static stringifyStyles(obj: Object) {
      let result = '';
      for (const prop in obj) {
        result += prop + ': ' + obj[prop] + ',';
      }

      return result.substr(0, result.length - 1);
    }

    static parseStyles(str: string) {
      const result = {};
      if (str != null && str.trim() !== '' ) {
        const attributes = str.split(',');
        for (const attribute of attributes) {
          const name = attribute.split(':')[0].trim();
          const value = attribute.split(':')[1].trim();
          result[name] = value;
        }
      }

      return result;
    }
}


// WEBPACK FOOTER //
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/dynamicStyle/dynamicStyleHelper.ts